// extracted by mini-css-extract-plugin
module.exports = {"peopleInput":"OnboardingPeopleInput_peopleInput__KWfVE","actions":"OnboardingPeopleInput_actions__KMfBn","actionButton":"OnboardingPeopleInput_actionButton__0ds_1"};